import { ApolloProvider } from '@apollo/client';
import { MuiThemeProvider } from '@material-ui/core/styles';
import QuotationWidget from './QuotationWidget';
import { QuotationProvider } from './contexts/QuotationContext';
import { LocaleProvider } from './contexts/LocaleContext';
import theme from './helpers/theme';
import client from './client';
import './font/font.css';

const App = () => (
  <MuiThemeProvider theme={theme}>
    <ApolloProvider client={client}>
      <QuotationProvider>
        <LocaleProvider>
          <QuotationWidget />
        </LocaleProvider>
      </QuotationProvider>
    </ApolloProvider>
  </MuiThemeProvider>
);

export default App;
